import * as HTTP_CODES from '../constants/http.codes';
import { forbiddenAction } from './error.handling';
import { ROOT_PATH, LOGIN_PATH } from '../constants/routes';
import { push } from 'react-router-redux';
import { clearToken } from '../services/local.storage';

export function extractErrorMessage(error) {
    if (!error) return null;

    if (Array.isArray(error.message)) {
        const firstError = error.message[0];
        if (firstError && firstError.msg) {
            return firstError.msg;
        }
    }
    if (typeof error.message === 'string') {
        return error.message;
    }
    if (typeof error.error === 'string') {
        return error.error;
    }

    return null;
}

export async function apiActionCreator(dispatch, request, success, actions = {}) {
    const response = await request();
    const errorDispatch = () => {
        const customErrorAction = actions.allErrors || actions[response.status];
        if (customErrorAction) {
            customErrorAction(response.json);
        } else {
            dispatch({
                type: HTTP_CODES.CODE_ACTIONS[response.status],
                json: response.json
            });
        }
    };
    switch (response && response.status) {
        case HTTP_CODES.OK_CODE:
        case HTTP_CODES.CREATED_CODE:
            return success(response.json);
        case HTTP_CODES.BAD_REQUEST_CODE:
        case HTTP_CODES.NOT_FOUND_CODE:
        case HTTP_CODES.SERVICE_UNAVAILABLE_CODE:
        case HTTP_CODES.INTERNAL_SERVER_ERROR_CODE:
        case HTTP_CODES.UNPROCESSABLE_ENTITY_CODE:
        case HTTP_CODES.TOO_MANY_REQUESTS_CODE:
            return errorDispatch();
        case HTTP_CODES.GONE_CODE:
            const goneAction = actions[response.status];
            if (goneAction) {
                return goneAction(response.json);
            }
            break;
        case HTTP_CODES.NOT_ACCEPTABLE_CODE:
            const notAcceptableAction = actions[response.status];
            if (notAcceptableAction) {
                return notAcceptableAction(response.json);
            }
            break;
        case HTTP_CODES.UNAUTHORIZED_CODE:
        case HTTP_CODES.FORBIDDEN_CODE:
            const customErrorAction = actions.allErrors || actions[response.status];
            if (customErrorAction) {
                return customErrorAction(response.json);
            } else {
                if (response.status === HTTP_CODES.UNAUTHORIZED_CODE && response.json?.message === 'jwt expired') {
                    clearToken();
                    return dispatch(push(LOGIN_PATH));
                }
                dispatch(push(ROOT_PATH));
                return dispatch(forbiddenAction());
            }
        default:
            return success({});
    }
}

export const apiMultipleCalls = async (
    dispatch,
    apiCalls,
    done,
    index = 0,
    results = {},
    collectAll = false,
    errorActions = {}
) => {
    const _continue = response => {
        if (collectAll) {
            results[index] = response;
        } else {
            results = Object.assign(results, response);
        }
        if (apiCalls[index + 1]) {
            apiMultipleCalls(dispatch, apiCalls, done, index + 1, results, collectAll, errorActions);
        } else {
            done(results);
        }
    };
    if (apiCalls.length) {
        await apiActionCreator(dispatch, apiCalls[index], _continue, {
            400: _continue,
            ...errorActions
        });
    } else {
        done({});
    }
};
